export default __webpack_public_path__ + "static/media/er2.7b81b094.jpg";